import { HttpHeaders } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/services/apiService';
import { SweetAlertService } from 'src/services/sweetAlertService';
import jwt_decode from "jwt-decode";
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/services/auth.service';
import { jamarekObj } from 'src/app/models/jamarekObj';
import { CustomValidators } from 'src/app/validator/custom-validators';

@Component({
  selector: 'app-edti-jamarek',
  templateUrl: './edti-jamarek.component.html',
  styleUrls: ['./edti-jamarek.component.css']
})

export class EdtiJamarekComponent {

  form!: FormGroup;
  statisticalUnits:any[]=[];
  units:any[][] = [];
  taxUnits:any[][] = [];
  carbonCopyId:string|undefined;
  hideadditionalCode=false;
  formSubmited:boolean=false;
  isLoading=true;

  showSaveBtn=true;
  
  employeeId:string|undefined;
  showJamarek=true;
  showTax=true;
  formType:string="1";
  //editAddionalCode=false;
  editHsCode=true;
  editQuantity=true;
  token:string="";
  mainPath = "" // قراءة القيمة من environment

  public exemptAssetsList:any[]=[];

  gamarekCount:number=0;
  taxCount:number=0;
  

  getExemptAssetsList(){

    

    var request=this.apiService.get("Moin/GetFindings",`${environment.govnet}`,undefined,this.token);;

    request.subscribe(response=>{
      var data=response.data.list as any[];

      var newList= data.map(item=>{

        var value=  item.value as string;

        var newValue=value.substring(0,50);

        return  {
          key:item.key,
          value:newValue,
        }

      });

      this.exemptAssetsList=newList;

    });
  }

  constructor(private fb: FormBuilder,private apiService:ApiService,private authService:AuthService,
    private route: ActivatedRoute,private alertService:SweetAlertService) {
      this.mainPath= environment.MainPath;

      document.addEventListener('scroll', (event) => {
        event.stopPropagation();  // Be cautious, as this can stop all scroll events in the document
      }, true);

    this.token= this.route.snapshot.queryParamMap.get('Token')!;

    this.getExemptAssetsList();
    this.fillStaticUnit();




    if(this.route.snapshot.queryParams['Token'] && this.route.snapshot.queryParams['Carponcopyid']){

      this.carbonCopyId= this.route.snapshot.queryParamMap.get('Carponcopyid')!;

      var TaxNumber = this.route.snapshot.queryParamMap.get('TaxNumber')!;

      this.formType= this.route.snapshot.queryParamMap.get('formType')!;
      
      if(this.formType=="2"){

        var showingType = this.route.snapshot.queryParamMap.get('show')!;

        if(showingType=="jamarek"){

          this.showJamarek=true;
          this.showTax=false;

        }else if(showingType=="tax"){

          this.showJamarek=false;
          this.showTax=true;

        }


      }

      this.form = this.fb.group({
        taxNumber:[TaxNumber, Validators.required],
        formItems: this.fb.array([]),
        taxItems: this.fb.array([]),
      });

      this.fillApplicant(this.carbonCopyId);

      var token = this.route.snapshot.queryParamMap.get('Token')!;

      var decoded = jwt_decode(token) as any;

      this.employeeId= decoded.sub;

      var roles=decoded.role as any[];

      if(roles.includes('ADCD_MOIN') || roles.includes('HCCD_MOIN') || roles.includes('CA_MOIN')){
        this.editHsCode=false;
      }

      if(roles.includes('HEID_MOIN') || roles.includes('EIESC_MOIN')){
        this.editQuantity=false;
      }
      
      this.checkValidty();

      //var role= decoded.role as string|string[];

    }else{
      location.href="/"+this.mainPath+"/Dashboard";
    }
  }

  calculateCounter(){

    this.gamarekCount=0;
    this.taxCount=0;

    this.Items.controls.map(item=>{

      if(item.get('totalPrice')?.value!=0 &&item.get('quantity')?.value!=0 ){
        this.gamarekCount+= item.get('totalPrice')?.value* item.get('quantity')?.value;
      }

    });

    this.TaxItems.controls.map(item=>{

      if(item.get('totalPrice')?.value!=0 &&item.get('quantity')?.value!=0 ){
        this.taxCount+= item.get('totalPrice')?.value* item.get('quantity')?.value;
      }

    });


  }

  checkValidty(){

    var request=this.apiService.get(`Moin/GetEditFormByConsumerStatus?carbonId=${this.carbonCopyId}`,`${environment.govnet}`,undefined,this.token);

    request.subscribe(response=>{

      this.isLoading=false;

      if(response.data.value==true){
        
        this.showSaveBtn=false;
        
      }
    });


  }


  generateItem(data?: {
    id?: number;
    unitName?: string;
    unitId?: string;
    quantity?: string;
    exemptAssets?: string;
    staticUnit?: string;
    additionalCode?: number;
    hsCode?: boolean;
    fromDb:boolean;
    totalPrice: number;
    description: string;
    note: string;
    credits: string;
  }): FormGroup {

    return this.fb.group({
      id: [data?.id ||0],
      unitName: [data?.unitName || '', Validators.required],
      unitId: [data?.unitId || '', [Validators.required]],
      quantity: [data?.quantity || '1', [Validators.min(1),Validators.required]],
      exemptAssets: [ data?.exemptAssets],
      staticUnit: [data?.staticUnit || '', Validators.required],
      additionalCode: [data?.additionalCode?.toString() !="" ? data?.additionalCode : ((data?.exemptAssets=="")? '':'708') , Validators.required ],
      hsCode: [data?.unitId || ''],
      fromDb: data?.fromDb??false,
      totalPrice: [data?.totalPrice || '1', [Validators.min(1),Validators.required]],
      description: [data?.description || '',[Validators.required,CustomValidators.emptyStringValidator]],
      note: [data?.note || ''],
      credits: [data?.credits || ''],
    });
    
  }

  get Items() {
    return this.form.get('formItems') as FormArray;
  }

  get TaxItems() {
    return this.form.get('taxItems') as FormArray;
  }

  addItem() {
    this.Items.push(this.generateItem());
  }

  addItemWithValue(data:FormGroup) {
    this.Items.push(data);
  }


  removeJamarek(index: number) {
    this.Items.removeAt(index);
  }

  removeTax(index: number) {
    this.TaxItems.removeAt(index);
  }

  addTaxItem() {
    this.TaxItems.push(this.generateItem({hsCode:false,staticUnit:"1",unitId:"1",fromDb:false,totalPrice:0,description:'',credits:'',note:''}));
  }

  addTaxItemWithValue(data:FormGroup) {
    this.TaxItems.push(data);
  }

  
  onSubmit() {

    this.formSubmited=true;

    if(this.form.valid){


      this.formSubmited=false;
      //this.showSaveBtn=false;

      var gamarekExemptionReqest:any[]=[];

      var taxExemptionReqest:any[]=[];

      let items = this.Items;
      let taxItems = this.TaxItems;
      this.isLoading=true;


      items.controls.forEach((control, index) => {

        let searchText= $(`#unitId-${index} option:selected`).text();

        var data={
          "id": control.get('id')?.value,
          "ssCode": control.get('unitId')?.value,
          "quantity": control.get('quantity')?.value,
          "statisticalUnit": control.get('staticUnit')?.value,
          "exemptAssets": control.get('exemptAssets')?.value,
          "additionalCode":control.get('additionalCode')?.value ,
          "totalPrice": control.get('totalPrice')?.value,
          "description":control.get('description')?.value ,
          "note":control.get('note')?.value ,
          "credits":String(control.get('credits')?.value) ,
          "searchKeyword": searchText
        };

        gamarekExemptionReqest.push(data);
      });

      taxItems.controls.forEach((control, index) => {

        //let searchText= $(`#texunitId-${index} option:selected`).text();

        var data={
          "id": control.get('id')?.value,
          "ssCode": control.get('unitId')?.value,
          "quantity": control.get('quantity')?.value,
          "statisticalUnit": control.get('staticUnit')?.value,
          "exemptAssets": control.get('exemptAssets')?.value,
          "additionalCode":control.get('additionalCode')?.value ,
          "searchKeyword": control.get('unitName')?.value,
          "totalPrice": control.get('totalPrice')?.value,
          "description":control.get('description')?.value ,
          "note":control.get('note')?.value ,
          "credits":String(control.get('credits')?.value) ,
        };

        taxExemptionReqest.push(data);
      });

      var body={
        "model":{
          "carponcopyid": this.carbonCopyId,
          "taxNumber": this.form.get('taxNumber')?.value,
          "userId": this.employeeId,
          "jamarekItems": gamarekExemptionReqest,
          "taxItems":taxExemptionReqest,
          "userType":"2",
        }
      }

      var request=this.apiService.post('Moin/SubmitExemptionForm',body,`${environment.govnet}`,undefined,this.token);;

        request.subscribe(response=>{

          this.isLoading=false;

          if(response){
            if(response.data.value==true){
              
              this.alertService.ShowAlert('success',' تم الحفظ بنجاح');
            }else{
              this.showSaveBtn=true;
            }
          }
        });



    }else{
      console.log(this.form);
    }
  }

  


  fillStaticUnit(){

    var request= this.apiService.get('Moin/GetStatisticalUnits' , `${environment.govnet}`,undefined,this.token);

    request.subscribe(response=>{
      var list=response.data.list;
      this.statisticalUnits=list;
    });

  }

  fillApplicant(carbonId:string){

    var request=this.apiService.get('Moin/GetJamarekTaxApplicantData?licenseId='+carbonId,`${environment.govnet}`,undefined,this.token);;

    request.subscribe(response=>{

      var jamarekImtems=response.data.jamarek as any[];

      var taxImtems=response.data.tax as any[];

      if(jamarekImtems.length>0){

        this.form.get('taxNumber')?.setValue(jamarekImtems[0].taxNumber);

        jamarekImtems.map((item,index)=>{


          var obj=new jamarekObj(item.id,item.searchKeyword,item.hsCode,item.remainingQuantity,item.statisticalUnit,item.additionalCode,item.exemptAssets,true,item.totalPrice,item.description,item.credits,item.note);
          var form= this.generateItem(obj);
          this.searchEnquiry(item.searchKeyword,index);
          this.addItemWithValue(form);

          this.isLoading=false;

        })
      }else{
        this.isLoading=false;
      }

      if(taxImtems.length>0){

        this.form.get('taxNumber')?.setValue(taxImtems[0].taxNumber);

        taxImtems.map((item,index)=>{

          var obj=new jamarekObj(item.id,item.searchKeyword,item.hsCode,item.remainingQuantity,item.statisticalUnit,item.additionalCode,item.exemptAssets,true,item.totalPrice,item.description,item.credits,item.note);
          var form= this.generateItem(obj);
          //this.searchTaxEnquiry(item.searchKeyword,index);
          this.addTaxItemWithValue(form);

          this.isLoading=false;

        });


      }else{

        this.isLoading=false;

      }

      this.calculateCounter();

    });

  }

  async getUnits(event:Event, index: number){
    
    const inputElement = event.target as HTMLInputElement; // Type assertion
    const text = inputElement.value;


    await this.searchEnquiry(text, index,true);

  }


  private searchEnquiry(text: string, index: number,refresh:boolean=false) {

    if(refresh){
      this.isLoading=true;
    }

    var request = this.apiService.get('Moin/GeneralEnquiry?description=' + text, `${environment.govnet}`,undefined,this.token);

    request.subscribe(response => {

      this.isLoading=false;

      this.units[index] = response.data.list as any[];
    });
  }


  onUnitIdChange(event: any, index: number) {
    const selectedUnitId = event.target.value;

    this.Items.controls.map(control=>{

      if(control.get('hsCode')?.value==selectedUnitId){

          this.alertService.ShowAlert('error','لا يمكن تكرار نفس العنصر');

          this.removeJamarek(index);

          return;

      }

    });
  
    const selectedUnit = this.units[index].find(unit => unit.key === selectedUnitId);

    if (selectedUnit) {
      const itemsArray = this.form.get('formItems') as FormArray;
      const itemGroup = itemsArray.at(index) as FormGroup;

      itemGroup.get('hsCode')?.setValue(selectedUnit.key);


    }
  }

  onTaxUnitIdChange(event: any, index: number) {
    const selectedUnitId = event.target.value;
  
    const selectedUnit = this.taxUnits[index].find(unit => unit.key === selectedUnitId);

    if (selectedUnit) {
      const itemsArray = this.form.get('taxItems') as FormArray;
      const itemGroup = itemsArray.at(index) as FormGroup;

      itemGroup.get('hsCode')?.setValue(selectedUnit.key);


    }
  }

  
}
